import { GA_MEASUREMENT_ID } from '../constants/googleAnalytics.js';

let initialized = false;

export function getGaMeasurementId() {
  return GA_MEASUREMENT_ID;
}

export function initGoogleAnalytics(measurementId) {
  if (!measurementId || initialized || typeof window === 'undefined') {
    return;
  }
  initialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);
}

export function trackGaPageView(pagePath, measurementId) {
  if (!measurementId || typeof window.gtag !== 'function') {
    return;
  }
  window.gtag('config', measurementId, {
    page_path: pagePath,
  });
}
